const requisitionCreateInputsGroupsById = ['orderingPhysician', 'createPatient', 'patientHistory', 'specimenInformation'];

export default requisitionCreateInputsGroupsById;